const store =  require('@os-store/booking/store');
store.mutations = {
  ...store.mutations,
  updateSingleData (state, {key, value}) {
    // 更新单个属性
    let data = state.data;
    if (data.hasOwnProperty(key)) {
      data[key] = value;
    }
  }
};
export default store



// WEBPACK FOOTER //
// ./store/booking/store.js